<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-10-26 09:40:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-24 22:00:41
-->
<template>
    <div class="nav">
        <div class="nav_box">
            <div class="nav_con">
                <!-- <el-dropdown>
                    <el-button type="primary">
                        會員中心
                    </el-button>
                    <el-dropdown-menu></el-dropdown-menu>
                </el-dropdown> -->
                <el-menu default-active="0"
                         class="el-menu-demo"
                         mode="horizontal">
                    <el-menu-item index="0">
                        <router-link :to="{ name: 'Index' }">
                            首頁
                        </router-link>
                    </el-menu-item>
                    <el-menu-item index="100">
                        <router-link :to="{ name: 'GoodList' }">
                            全部商品
                        </router-link>
                    </el-menu-item>
                    <el-menu-item v-for="item in goods_list"
                                  :key="item.id"
                                  :index="item.id.toString()">
                        <router-link :to="`/GoodList?id=${item.id}`">
                            {{ item.list_name }}
                        </router-link>
                    </el-menu-item>
                    <el-menu-item index="200">
                        <router-link :to="{ name: 'Leaderboard' }">
                            排行榜
                        </router-link>
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
</template>

<script>
// 辅助函数，可以使用命名空间获取$store的数据
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("BasicInfo", ["goods_list", "isLoading"]),
    },
};
</script>

<style scoped lang="scss">
.nav {
    background-color: #fff;
    .nav_box {
        width: 100%;
        border-bottom: 3px solid #ff2832;
        background-color: #fff;
        .nav_con {
            width: 1000px;
            margin: 0 auto;
            height: auto;
            overflow: hidden;
            .el-dropdown {
                float: left;
                button {
                    width: 200px;
                    background-color: #ff2832;
                    border-color: #ff2832;
                    border-radius: 0;
                }
            }
            .el-menu {
                float: left;
                border: none;
                .el-menu-item {
                    height: 40px;
                    line-height: 40px;
                    color: #323232;
                    font-weight: bold;
                }
                .el-menu-item:first-child {
                    margin-left: 20px;
                }
                .el-menu-item a:hover {
                    color: #ff2832;
                }
            }
        }
    }
    .nav_bottom {
        font-size: 12px;
        background: #f5f5f5;
        ul {
            height: 31px;
            margin: 0 auto;
            overflow: hidden;
            line-height: 30px;
            width: 1000px;
            li {
                float: left;
                a {
                    color: #646464;
                    padding: 0 15px;
                }
                a:hover {
                    color: #ff2832;
                    text-decoration: underline;
                }
                span {
                    color: #ccc;
                }
            }
        }
    }
}
.el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: none;
}
</style>
